
import { isMiniApplets } from '@/utils/browser'

let miniApp = isMiniApplets() || 'wechat'

let shareEnums = {
    wechat:  '/PagesB/Activity/CollectCardShare/index',
    alipay:  '/pagesB/activity/collectCardShare/collectCardShare'
}

let shareUrl = shareEnums[miniApp]

const mini = {
    shareUrl
}

export default mini